import { render, staticRenderFns } from "./benefitBtnWrap.vue?vue&type=template&id=3b9ddede&"
import script from "./benefitBtnWrap.vue?vue&type=script&lang=js&"
export * from "./benefitBtnWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports